import MyGames from './my-games';

export default MyGames;
